<template>
	<div tabindex="0" @keyup.esc="closeAdd()" class="hide-outline">
		<TopPanel
			:units="[$t('ongoingmoves.unit_single'), $t('ongoingmoves.unit_plural'), $t('ongoingmoves.unit_new')]"
			:pagination="pagination"
			:showCustomer="true"
			:orderBys="orderBys"
			:orderBy="searchParams.orderBy"
			:hide-add="!$isAllowedTo('roundplannings_edit')" 
			@toggleAdd="navigate"
			@search="search"
			@orderBy="orderBy"
		/>
		<main class="main-view columns">
			<OngoingMovesList
				:moves="moves"
				:pagination="pagination"
				@delete="askToDelete"
				@edit="edit"
				@paginate="paginate"
			/>
		</main>
		<DeleteModal
			v-if="showDelete"
			@confirm="deleteSelected"
			@cancel="cancelDelete"
			:message="deleteMessage"
		/>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import OngoingMovesList from './components/OngoingMovesList';
import DeleteModal from '@/components/DeleteModal';
import TopPanel from '@/components/TopPanel';
import moveWizard from '@/services/moveWizard';

export default {
	components: {
		OngoingMovesList,
		DeleteModal,
		TopPanel
	},

	data() {
		return {
			showDelete: false,
			selectedMove: {},
			searchParams: {
				pageNumber: 1,
				PageSize: 10
			},
			pagination: {
				currentPage: 1,
				pageSize: 10,
				totalCount: 0,
				totalPages: 1
			},
			moves: []
		};
	},

	computed: {
		...mapGetters('user', ['getActiveCustomer']),

		deleteMessage() {
			return this.selectedMove.fromCustomerName && this.selectedMove.targetCustomerName
				? this.$t('ongoingmoves.delete_confirmation', {
					from: this.selectedMove.fromCustomerName,
					to: this.selectedMove.targetCustomerName
					})
				: '';
		},
		orderBys() {
			return [
				{ name: this.$t('ongoingmoves.order_by_name'), value: 'Name' },
				{ name: this.$t('ongoingmoves.order_by_created'), value: 'Created' }
			];
		}
	},

	watch: {
		'getActiveCustomer.id'() {
			this.moves = [];
			this.getMoves();
		}
	},

	created() {
		this.getMoves();
	},

	methods: {
		navigate() {
			let id = this.selectedMove.id || 0;
			
			if (id === 0 || this.selectedMove.moveStatus === 0) {
				this.$router.push({
					name: 'MoveWizardView',
					params: {
						moveId: id
					}
				});
			} else {
				this.$router.push({
					name: 'MoveSummaryView',
					params: {
						moveId: id
					}
				});
			}
			
		},

		edit(move) {
			Object.assign(this.selectedMove, move);
			this.navigate();
		},

		askToDelete(move) {
			this.showAdd = false;
			Object.assign(this.selectedMove, move);
			this.showDelete = true;
		},

		cancelDelete() {
			this.showDelete = false;
			this.selectedMove = {};
		},

		deleteSelected() {
			moveWizard.deleteMove(this.selectedMove.id).then(() => {
				this.showDelete = false;
				this.selectedMove = {};
				this.getMoves();
			});
		},

		search(searchValue) {
			this.searchParams.search = searchValue;
			this.getMoves();
		},
		
		paginate(pageNumber, pageSize) {
			this.searchParams.pageNumber = pageNumber;
			
			if (pageSize) {
				this.searchParams.pageSize = pageSize;
			}
			
			this.getMoves();
		},

		orderBy(orderBy) {
			this.searchParams.orderBy = orderBy;
			this.getMoves();
		},

		getMoves() {
			moveWizard.getMoves(this.searchParams).then(response => {
				this.moves = response;
				this.pagination = response._pagination;
			});
		}
	}
};
</script>